import { useState } from "react";
import { useTranslation } from "react-i18next";

// Sezione bio pubblica ("Chi sono" / "Chi siamo"): niente box se vuota, "Mostra altro" se lunga.
export function PublicBio({ title, text, testid }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const clean = (text || "").trim();
  if (!clean) return null;
  const long = clean.length > 320;
  const shown = open || !long ? clean : clean.slice(0, 320).trimEnd() + "…";
  return (
    <div className="yp-card p-6 mt-6" data-testid={testid}>
      <h2 className="text-lg font-bold text-slate-800 mb-2">{title}</h2>
      <p className="text-slate-700 whitespace-pre-line">{shown}</p>
      {long && (
        <button className="mt-2 text-sm font-medium text-blue-600 hover:underline" onClick={() => setOpen(o => !o)} data-testid={`${testid}-toggle`}>
          {open ? t("orgx.show_less") : t("orgx.show_more")}
        </button>)}
    </div>);
}
